import { commonUtil } from '@/util'
const request = {}

request.createRequest = function (params) {
  return {
    controlType: params.controlType,
    uid: params.neUid,
    state: params.neState
  }
}
export default { request }
